<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid pb-4" style="background-color: white">
            <h2 class="pt-4" style="text-align: center">บันทึกรายได้อื่นๆ</h2>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกวันที่
                        </label>
                        <div class="col-sm-4">
                            <date-picker
                                :format="changeFormat"
                                :lang="lang"
                                class="text-center w-100"
                                placeholder="วันที่"
                                type="date"
                                v-model="date">
                            </date-picker>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกรายการ
                        </label>
                        <div class="col-sm-4">
                            <multiselect
                                :customLabel="typeLabel"
                                :options="optionList"
                                deselectLabel=""
                                placeholder="เลือกประเภท"
                                select-label=""
                                track-by="key"
                                v-model="typePay">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table mt-4">
                <table align="center" class="table-borderless">
                    <tr v-for="(detail,index) in employeeList">
                        <td width="200">รหัสพนักงาน</td>
                        <td width="250">
                            <multiselect
                                :customLabel="employeeLabel"
                                :options="optionEmployee"
                                deselectLabel=""
                                placeholder="เลือกพนักงาน"
                                select-label=""
                                track-by="id"
                                v-model="detail.employee_id">
                            </multiselect>
                        </td>
                        <td width="100">จำนวน</td>
                        <td width="250">
                            <input class="form-control"
                                   min="1" type="number"
                                   v-model="detail.price" v-on:keypress="isNumber()"
                            />
                        </td>
                        <td width="100"><label>บาท</label></td>
                        <td width="200">
                                <textarea :disabled="checkReason"
                                          class="form-control"
                                          v-model="detail.reason"
                                          placeholder="หมายเหตุ"
                                />

                        </td>
                        <td width="100">
                            <!--เพิ่ม-->
                            <button @click="addShoppingDetails" class="btn btn-primary"
                                    type="button"
                                    v-if="employeeList.length == index+1">
                                <icon name="plus"></icon>
                            </button>
                            <!--ลบ-->
                            <button @click="removeShoppingDetails(index)" class="btn btn-danger"
                                    type="button"
                                    v-if="index+1 < employeeList.length">
                                <icon name="trash"></icon>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="col text-center">
                <button @click="saveOther"
                        class="btn btn-success"
                        type="button">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;
                &nbsp;
                <button @click="goToIncomeList"
                        class="btn btn-outline-secondary"
                        type="button">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>

        </div>
        <!--            <pre class="alert-primary">{{form}}</pre>-->
    </div>

</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    name: "other-payment-form",
    components: {
        Multiselect, DatePicker
    },
    created() {
        this.$store.dispatch('ShoppingEmployee/clearFormDataIncome');
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.optionEmployee = res;
        });
        this.$store.dispatch("Employee/getTypeListIncome").then(res => {
            this.optionList = res;
        });
    },
    data() {
        return {
            optionEmployee: [],
            employeeList: [{
                employee_id: [],
                price: "",
                recorder: "",
                date: "",
                select_type_income: '',
                reason: ''
            }],
            optionList: [],
            currentDate: "",
            date: '',
            typePay: '',
            items: [
                {
                    text: "รายการรายรับ",
                    to: {name: "other-recive"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/' + year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            form: state => {
                return state.ShoppingEmployee.incomeEmployeeForm;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        checkReason() {
            return !(this.typePay);
            // return !(this.typePay && this.typePay.key == "income_other");
        }
    },
    methods: {
        isNumber() {
            let evt = window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        typeLabel(option) {
            return `${option.value}`
        },
        goToIncomeList() {
            this.$router.push({
                name: "other-recive"
            })
        },
        addShoppingDetails() {
            this.employeeList = [
                ...this.employeeList,
                {
                    employee_id: [],
                    price: "",
                    recorder: "",
                    date: "",
                    reason: ''
                }
            ];
        },
        removeShoppingDetails(index) {
            this.employeeList = this.employeeList.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        cleaData() {
            this.employeeList = [{
                employee_id: [],
                price: "",
                recorder: "",
                date: "",
                select_type_income: '',
                reason: ''
            }];
        },
        saveOther() {
            if (!this.typePay) {
                alert('กรุณาเลือกประเภทรายการหัก');
            } else if (!this.date) {
                alert('กรุณาเลือกวันที่');
            } else {
                this.employeeList.forEach(detail => {
                    if (detail.employee_id != 0) {
                        if (!detail.employee_id) alert('กรุณาเลือกพนักงานให้ครบ');
                        else detail.employee_id = detail.employee_id.id;
                    }
                    detail.recorder = this.user.name;
                    this.currentDate = moment().format("YYYY-MM-DD");
                    detail.date = this.date ? moment(this.date).format("YYYY-MM-DD") : '';
                    detail.select_type_income = this.typePay ? this.typePay.key : '';
                })
                this.$store.dispatch('ShoppingEmployee/saveOtherIncome', {
                    data: this.employeeList
                }).then(() => {
                    this.goToIncomeList();
                })
            }
        },
    }
}
</script>

<style scoped>

</style>
